import menuDataEN from '../../prismic-mega-menu-EN.json';
import menuDataFR from '../../prismic-mega-menu-FR.json';
import type { MenuItem } from './types';
import { transformMenuData } from '_utils/transformMenuUrl';

const browserOrigin =
  typeof window !== 'undefined' ? window.location.origin : undefined;

export const menuDataByLocale: Record<string, MenuItem[]> = {
  en: transformMenuData(menuDataEN as MenuItem[], browserOrigin),
  fr: transformMenuData(menuDataFR as MenuItem[], browserOrigin),
};
